module.exports = {
    asoleacionData: () => {
        return[
            {
                "asoleacion":[
                    {
                        "hours":[
                            {
                                "image":require("./../UI/icons/POI/Comercio2.svg"),
                                "second":"0.5"
                            },
                            {
                                "image":require("./../UI/icons/POI/Comercio2.svg"),
                                "second":"1"
                            },
                            {
                                "image":require("./../UI/icons/POI/Comercio2.svg"),
                                "second":"1.5"
                            },
                            {
                                "image":require("./../UI/icons/POI/Comercio2.svg"),
                                "second":"2"
                            },
                        ],
                        "initialTime":"1.2",
                        "vistas":{
                            "V1": {
                                "video":require("./../UI/Video/0ebafeba-53cf-4289-98f9-2d68e6342630.mp4"),
                                "angle":"40"
                            },
                            "V2": {
                                "video":require("./../UI/Video/9cbdaf1e-5e95-4610-b8bf-668d8dc5c58e.mp4"),
                                "angle":"60"
                            },
                            "V3": {
                                "video":require("./../UI/Video/edc9bfb9-eb74-44c4-9e3e-3fdd5718adad.mp4"),
                                "angle":"120"
                            }
                        }
                    }
                ]
            }
        ]
    }
}